export default __webpack_public_path__ + "static/media/loading.555157e6.gif";